/* eslint-disable @next/next/no-img-element */
import { useEffect, useState } from "react";
import { toast } from 'react-toastify';
import { getCookie } from "framework/libs/cookie";
import { TOKEN_CONGDONG, TOKEN_SHOP } from "framework/store/constants";
import http from 'utilities/http';
import {isArray} from 'lodash';

export default function HoSo({ }) {
    const [current_password, setcurrent_password] = useState('');
    const [password, setpassword] = useState('');
    const [password_confirmation, setpassword_confirmation] = useState('');
    const [showPW, setShowPW] = useState([false,false,false]);
    const updateUser = async () => {
        const res = await http('user/change-password', {}, {
            body: {
                current_password: current_password,
                password: password,
                password_confirmation: password_confirmation,
            },
            method: 'POST',
            token: 'Bearer ' + getCookie(TOKEN_CONGDONG)
        }, 'v2');
        if (res.code === 200) toast.info('Thay đổi thành công!');
        if (res.code !== 200) toast.error(isArray(res.errors.password) ? res.errors.password[0] : res.errors.password);
    };
    return (<>
        <div className="form-change-password">
            <div className="form-group">
                <label className="form-title">Mật khẩu hiện tại</label>
                <div className="form-icon icon-right">
                    <input className="form-control" type={showPW[0]? "text" : "password" } name="" placeholder="Nhập mật khẩu hiện tại" value={current_password}
                        onChange={(e) => setcurrent_password(e.target.value)}/>
                    {current_password.length > 0 &&
                        <span className="icon"><img src="/images/icon-tick.svg" alt=""  onClick={()=> setShowPW( [!showPW[0],showPW[1],showPW[2]])}/></span>
                    }
                </div>
            </div>
            <div className="form-group">
                <label className="form-title">Mật khẩu mới</label>
                <div className="mb-2">
                    <div className="form-icon icon-right">
                        <input className="form-control" type={showPW[1]? "text" : "password" } name="" placeholder="Nhập mật khẩu mới" value={password}
                            onChange={(e) => setpassword(e.target.value)} />
                        {password.length > 0 &&
                        <span className="icon"><img src="/images/icon-tick.svg" alt="" onClick={() => setShowPW([showPW[0], !showPW[1], showPW[2]])}/></span>
                        }
                    </div>
                </div>
                <div className="mb-2">
                    <div className="form-icon icon-right">
                        <input className="form-control" type={showPW[2]? "text" : "password" } name="" placeholder="Nhập lại mật khẩu mới" value={password_confirmation}
                            onChange={(e) => setpassword_confirmation(e.target.value)} />
                        {password_confirmation.length > 0 &&
                        <span className="icon"><img src="/images/icon-tick.svg" alt="" onClick={() => setShowPW([showPW[0], showPW[1], !showPW[2]])}/></span>
                        }
                    </div>
                </div>
                <button className="btn btn--blue btn-change-pass" onClick={updateUser}>Đổi mật khẩu</button>
            </div>
        </div>
    </>
    );
}